// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"500a88d9","484":"fb026695","551":"9c81f967","851":"b6f5b30c"}[chunkId] + ".chunk.js";
};